/* istanbul ignore file */
import { injectIntl, IntlShape } from 'react-intl';
import { get, uniqueId, isEmpty, sortBy } from 'lodash';
import { Paper } from '@material-ui/core';
import { Tab, Tabs } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import Timeline from '@material-ui/lab/Timeline';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import moment from 'moment-timezone';
import {
  renderAction,
  renderEvent,
  renderParam,
} from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/utils';
import { formatSagisMessage } from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/utils';
import {
  StyledPaper,
  StyledTitle,
  StyledDate,
  StyledPaperBlue,
  StyledTitleBlue,
} from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/style';
import withLoading from 'containers/AppContainer/withLoading';
import { EVENTS } from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/constants';

export interface TimeLineContentProps {
  intl: IntlShape;
  listings: any;
  loaders: any;
  claimHistorySagis: any;
  setTab: Function;
  userActions: any;
  tab: any;
}
const TimeLineContent = (props: TimeLineContentProps) => {
  const handleChange = (event: React.ChangeEvent<{}>, newTabIndex: number) => {
    props.setTab(newTabIndex);
  };
  return (
    <div className="content">
      <Tabs
        value={props.tab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        className="tab-container"
      >
        <Tab label={translate(messages.allTitle, props)} data-testid="tab-1" />
        <Tab
          label={translate(messages.bawabaTitle, props)}
          data-testid="tab-2"
        />
        <Tab
          label={translate(messages.sagisTitle, props)}
          data-testid="tab-3"
        />
      </Tabs>
      {props.tab === 0 && (
        <Timeline>
          {isEmpty(
            formatSagisMessage(
              get(props.claimHistorySagis, 'data.claimHistoryMessage', []),
              props.userActions,
            ),
          ) ? (
            <></>
          ) : (
            formatSagisMessage(
              get(props.claimHistorySagis, 'data.claimHistoryMessage', []),
              props.userActions,
            )?.map((item: any) => (
              <TimelineItem>
                <TimelineOppositeContent
                  style={{
                    flex: 'unset !important',
                  }}
                ></TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent key={uniqueId('timeLine')}>
                  {get(item, 'isCorpo', false) ? (
                    <Paper elevation={0} style={StyledPaper}>
                      <Grid container direction="column">
                        <span style={StyledTitle}>
                          {get(item, 'userName') +
                            ' ' +
                            renderAction(
                              get(item, 'event.title') === EVENTS.FRAUDE
                                ? ''
                                : get(item, 'action.title'),
                            ) +
                            ' ' +
                            renderEvent(get(item, 'event.title')) +
                            renderParam(item, props.listings, props)}
                        </span>
                        <span style={StyledDate}>
                          {item.createdAt &&
                            moment(item.createdAt).format(
                              'DD/MM/YYYY HH:mm:ss',
                            )}
                        </span>
                      </Grid>
                    </Paper>
                  ) : (
                    <Paper elevation={0} style={StyledPaperBlue}>
                      <Grid container direction="column">
                        <span style={StyledTitleBlue}>{item.item}</span>
                      </Grid>
                    </Paper>
                  )}
                </TimelineContent>
              </TimelineItem>
            ))
          )}
        </Timeline>
      )}

      {props.tab === 1 && (
        <Timeline>
          {isEmpty(props.userActions) ? (
            <></>
          ) : (
            sortBy(props.userActions, 'createdAt')?.map(
              (item: {
                title: string;
                createdAt: string;
                id: number;
                createdBy: string;
              }) => (
                <TimelineItem>
                  <TimelineOppositeContent
                    style={{
                      flex: 'unset !important',
                    }}
                  ></TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent key={uniqueId('timeLine')}>
                    <Paper elevation={0} style={StyledPaper}>
                      <Grid container direction="column">
                        <span style={StyledTitle}>
                          {get(item, 'userName') +
                            ' ' +
                            renderAction(
                              get(item, 'event.title') === EVENTS.FRAUDE
                                ? ''
                                : get(item, 'action.title'),
                            ) +
                            ' ' +
                            renderEvent(get(item, 'event.title')) +
                            renderParam(item, props.listings, props)}
                        </span>
                        <span style={StyledDate}>
                          {item.createdAt &&
                            moment(item.createdAt).format(
                              'DD/MM/YYYY HH:mm:ss',
                            )}
                        </span>
                      </Grid>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ),
            )
          )}
        </Timeline>
      )}
      {props.tab === 2 && (
        <Timeline>
          {isEmpty(
            get(props.claimHistorySagis, 'data.claimHistoryMessage', []),
          ) ? (
            <></>
          ) : (
            get(props.claimHistorySagis, 'data.claimHistoryMessage', [])?.map(
              (item: string) => (
                <TimelineItem key={uniqueId('timeLine')}>
                  <TimelineOppositeContent
                    style={{
                      flex: 'unset !important',
                    }}
                  ></TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={0} style={StyledPaperBlue}>
                      <Grid container direction="column">
                        <span style={StyledTitleBlue}>{item}</span>
                      </Grid>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ),
            )
          )}
        </Timeline>
      )}
    </div>
  );
};

export default withLoading(injectIntl(TimeLineContent), [
  LOADERS.TRACKING_USER,
]);
